import React from 'react';
import PhoneInput from 'react-phone-input-2';
import classnames from 'classnames';
import { arrayOf, func, string } from 'prop-types';
import { assocPath } from 'rambdax';
import translate from '@/lib/intl/translate';
import { DonorType } from '@/propTypes';

function EditDonorPhoneInput({ data, errors, path, updateData }) {
  const [hasFocus, setHasFocus] = React.useState(false);
  const handleFocus = () => setHasFocus(true);
  const handleBlur = () => setHasFocus(false);
  const onChange = (_value, _country, _e, formattedValue) => {
    updateData(
      path ? assocPath(path, formattedValue, data) : formattedValue,
      path,
    );
  };

  const invalid = !!errors?.['intl-phone-input'];

  return (
    <PhoneInput
      containerClass={classnames('inline-flex flex-col', {
        'Mui-focused': hasFocus,
        'Mui-error': invalid,
      })}
      country="us"
      defaultErrorMessage={translate('ERRORS_MISSING_REQUIRED_FIELD', {
        field: translate('PHONE_NUMBER_LABEL'),
      })}
      enableSearch
      inputClass="pt-[11.5px] pb-[11.5px] h-[1.4375em] rounded-lg flex w-auto box-content"
      inputProps={{
        name: 'intl-phone-input',
        required: translate('ERRORS_MISSING_REQUIRED_FIELD', {
          field: translate('PHONE_NUMBER_LABEL'),
        }),
      }}
      onBlur={handleBlur}
      onChange={onChange}
      onFocus={handleFocus}
      specialLabel={translate('PHONE_NUMBER_LABEL')}
      value={data?.number}
    />
  );
}

EditDonorPhoneInput.propTypes = {
  data: DonorType.isRequired,
  errors: arrayOf(string).isRequired,
  path: string.isRequired,
  updateData: func.isRequired,
};

export default EditDonorPhoneInput;
